import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ILocation } from "../models/ILocation";
import { useTranslation } from "react-i18next";
import { getActuatorLocations, getActuators, toggleRelay } from "../actions/actuatorActions";
import { ActuatorChannel, IActuator } from "../models/types";
import Actuator from "../components/Actuator";
// import { LocationDropdown } from "../components/LocationDropdown";

interface Props {
    dispatch: Function;
    locations: ILocation[];
    // actuators?: IActuator[];
}

const Actuators: React.FC<Props> = ({ dispatch, locations }) => {
    const { i18n } = useTranslation();
    const [actuators, setActuators] = useState<IActuator[]>([]);

    function fetchActuators() {
        getActuators()
            .then(res => {
                setActuators(res as IActuator[])
            })
            .catch(err => {
                console.error(err);
            })
    }

    useEffect(() => {
        fetchActuators();
        dispatch(getActuatorLocations());
        const intervalId = setInterval(fetchActuators, 10000);
        return () => clearInterval(intervalId); // Cleanup
    }, [dispatch]);

    if (actuators !== undefined && Array.isArray(actuators) && actuators.length > 0) {
        return (
            <>
                <div style={{
                    display: 'grid', gridTemplateColumns: '1fr 1fr',
                    gridTemplateRows: 'auto auto auto', gap: '10px'
                }}>
                    {actuators.map((elem: IActuator, key: number) =>
                    (
                        <Actuator actuator={elem} key={key}  />
                    ))}
                </div >
                {/* <LocationDropdown locations={locations} />
                <p>todo: add location selector</p> */}
            </>
        )
    } else {
        return (<>
            No actuators found
        </>)
    }
}

const mapStateToProps = (state: any) => ({
    locations: state.actuators.locations,
    actuators: state.actuators.actuators,
});

// const mapStateToProps = (state: any) => {
//     // debugger;

//     return {
//         locations: state.actuators.locations,
//         actuators: state.actuators.actuators,
//     };
// }

export default connect(mapStateToProps)(Actuators);